import { IDeclaracaoPrimeiroAdquirente } from '../../../interfaces/IDeclaracoes';
import { IFilialLista, IIdentificacaoBasica } from '../../../interfaces/IIdentificacaoBasica';
import { IMunicipio, IProcessoMinerario } from '../../../interfaces/IProcessos';
import { useApiClient } from '../../../hooks/useApiClient';
import { ICodigoNcm } from '../../../interfaces/ICodigoNcm';
import { IRegimeTributacao } from 'interfaces/IRegimeTributacao';
import { ITributos } from 'interfaces/ITributos';

export const useBackEndRequests = () => {
  const httpCall = useApiClient();

  const getDeclaracoes = async (cnpj: string, ano: string, tipo: number) => {
    const resposta = await httpCall.get<IDeclaracaoPrimeiroAdquirente[]>(
      `/dief-cfem/api/declaracao/primeiro-adquirente/listar/${cnpj}/ano/${ano}`
    );

    return resposta.data;
  };

  const getIdentificacaoBasica = async (cnpj: string) => {
    const resposta = await httpCall.get<IIdentificacaoBasica>(`/dief-cfem/api/declarante/${cnpj}`);

    return resposta.data;
  };

  const getIsProcessosPLG = async (numeroProcesso: string) => {
    const resposta = await httpCall.get<IProcessoMinerario>(
      `/dief-cfem/api/processo-minerario/lavra-garimpeira/${numeroProcesso}`
    );

    return resposta.data;
  };

  const postEnviarDeclaracao = async (declaracao: IDeclaracaoPrimeiroAdquirente) => {
    await httpCall
      .post<IDeclaracaoPrimeiroAdquirente>(`/dief-cfem/api/declaracao/primeiro-adquirente/enviar`, declaracao)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const postSalvarRascunhoDeclaracao = async (declaracao: IDeclaracaoPrimeiroAdquirente) => {
    await httpCall
      .post<IDeclaracaoPrimeiroAdquirente>(`/dief-cfem/api/declaracao/primeiro-adquirente/rascunho`, declaracao)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getMunicipioByCodigoIBGE = async (codigoIBGE: string) => {
    const resposta = await httpCall.get<IMunicipio>(`/dief-cfem/api/localidade/municipio/${codigoIBGE}`);
    return resposta.data;
  };

  const getDeclaracaoById = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IDeclaracaoPrimeiroAdquirente>(`/dief-cfem/api/declaracao/${declaracaoID}`);
    return resposta.data;
  };

  const deleteDeclaracaoById = async (declaracaoID: string) => {
    const resposta = await httpCall.delete<IDeclaracaoPrimeiroAdquirente>(
      `/dief-cfem/api/declaracao/retificacao/cancelar/${declaracaoID}`
    );
    return resposta.data;
  };

  const getRetificarDeclaracao = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IDeclaracaoPrimeiroAdquirente>(
      `/dief-cfem/api/declaracao/retificacao/retificar/${declaracaoID}`
    );
    return resposta.data;
  };

  const getRascunhoDeclaracao = async (declaracaoID: string) => {
    const resposta = await httpCall.get<IDeclaracaoPrimeiroAdquirente>(
      `/dief-cfem/api/declaracao/primeiro-adquirente/rascunho/${declaracaoID}`
    );
    return resposta.data;
  };

  const getRecibo = async (declaracaoID: string) => {
    const resposta = await httpCall.get<Blob>(`/dief-cfem/api/report/primeiro-adquirente/recibo/${declaracaoID}`, {
      responseType: 'blob',
    });
    return resposta.data;
  };

  const getCodigosNCM = async () => {
    const resposta = await httpCall.get<ICodigoNcm[]>(`/dief-cfem/api/ncm`);

    return resposta.data;
  };

  const getMunicipioPorUf = async (uf: string) => {
    const resposta = await httpCall.get<IMunicipio[]>(`/dief-cfem/api/localidade/uf/${uf}`);

    return resposta.data;
  };

  const getRegimesTributacao = async (cpfCnpj: string) => {
    const resposta = await httpCall.get<IRegimeTributacao[]>(`/dief-cfem/api/regime-tributacao/${cpfCnpj}`);
    return resposta.data;
  };

  const getListaFiliaisDeclaracaoAnterior = async (cpfCnpj: string, tipoDeclaracao: number) => {
    const resposta = await httpCall.get<IFilialLista[]>(
      `/dief-cfem/api/filial/declaracao-anterior/${cpfCnpj}/${tipoDeclaracao}`
    );
    return resposta.data;
  };

  const getTributos = async (numeroProcesso: string, mes: number, ano: number) => {
    const resposta = await httpCall.get<ITributos>(
      `/dief-cfem/api/declaracao/primeiro-adquirente/tributo?processo=${numeroProcesso}&mes=${mes}&ano=${ano}`
    );
    return resposta.data;
  };

  return {
    getDeclaracaoById,
    getDeclaracoes,
    deleteDeclaracaoById,
    getIdentificacaoBasica,
    getIsProcessosPLG,
    postEnviarDeclaracao,
    postSalvarRascunhoDeclaracao,
    getMunicipioByCodigoIBGE,
    getRetificarDeclaracao,
    getRascunhoDeclaracao,
    getRecibo,
    getCodigosNCM,
    getMunicipioPorUf,
    getRegimesTributacao,
    getListaFiliaisDeclaracaoAnterior,
    getTributos,
  };
};
